var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame2147207309(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3432_9766)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.91016 4.46875V13H3.7793V4.46875H4.91016ZM14.2793 4.46875V13H13.1426L8.84766 6.41992V13H7.7168V4.46875H8.84766L13.1602 11.0664V4.46875H14.2793Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.70703 14.1719H15.2871V14.7578H2.70703V14.1719Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("a", {
    href: "https://www.facebook.com/christian.karbet/"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillOpacity: 0,
    x: 2.70703,
    y: 1.96875,
    width: 12.5801,
    height: 14.0625
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3432_9766)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4044 0.678711H1.59797C1.09082 0.678711 0.679688 1.08984 0.679688 1.59699V16.4034C0.679688 16.9105 1.09082 17.3217 1.59797 17.3217H16.4044C16.9115 17.3217 17.3227 16.9105 17.3227 16.4034V1.59699C17.3227 1.08984 16.9115 0.678711 16.4044 0.678711Z",
    fill: "#3D5A98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.162 17.3202V10.8754H14.3248L14.6482 8.36383H12.162V6.7607C12.162 6.03367 12.3645 5.53726 13.4065 5.53726H14.7368V3.28726C14.0926 3.22025 13.4452 3.18833 12.7976 3.19164C10.8823 3.19164 9.5632 4.35883 9.5632 6.5118V8.36383H7.40039V10.8754H9.5632V17.3202H12.162Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3432_9766"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3432_9766"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame2147207309);
export default __webpack_public_path__ + "static/media/Frame 2147207309.10a9243030ad9b359403ddd8c9547cf6.svg";
export { ForwardRef as ReactComponent };